import offerCardMob1 from '../../assets/img/offercardMob1.svg';
import offerCardMob2 from '../../assets/img/offercardMob2.svg';
import offerCardMob3 from '../../assets/img/offercardMob3.svg';
import offerCardMob4 from '../../assets/img/offercardMob4.svg';
import offerCardMob5 from '../../assets/img/offercardMob5.svg';
import offerCardMob6 from '../../assets/img/offercardMob6.svg';
import offerCardMob7 from '../../assets/img/offercardMob7.svg';
import offerCardMob8 from '../../assets/img/offercardMob8.svg';

const cardDataMob= (t) => {
  const cardDataDataMob= [
    {
      img:offerCardMob1,
      description:t( "offer_card_capture1"),
      text:t("offer_card_description1")
    },
    {
      img:offerCardMob2,
      description:t( "offer_card_capture2"),
      text:t("offer_card_description2")
    },
    {
      img:offerCardMob3,
      description:t( "offer_card_capture3"),
      text:t("offer_card_description3")
    },
    {
      img:offerCardMob4,
      description:t( "offer_card_capture4"),
      text:t("offer_card_description4")
    },
    {
      img:offerCardMob5,
      description:t( "offer_card_capture5"),
      text:t("offer_card_description5")
    },
    {
      img:offerCardMob6,
      description:t( "offer_card_capture6"),
      text:t("offer_card_description6")
    },
    {
      img:offerCardMob7,
      description:t( "offer_card_capture7"),
      text:t("offer_card_description7")
    },
    {
      img:offerCardMob8,
      description:t( "offer_card_capture8"),
      text:t("offer_card_description8")
    }
  ]
  return cardDataDataMob;
}
  export default cardDataMob;